import { IInitialConfig } from '../app/interfaces/config.interface';

// @todo clean and integrate with initialConfig
export const environment = {
    production: false,
};

export const initialConfig: () => IInitialConfig = () => window.ConfigInitial;
